import { Pipe, PipeTransform } from "@angular/core";
import { ServiceService } from "../../providers/services.service";

@Pipe({
  name: "service",
})
export class ServicePipe implements PipeTransform {

  constructor(
    private serviceData: ServiceService,
  ) { }

  public transform(idService: string, clientId: string, eventId: string) {
    return this.serviceData.getById(clientId, idService, eventId);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/service/service.ts